import React from "react";
import "./ProviderCTA.scss";

const ProviderCTA = () => {
  return (
    <section className="providerDreams" id="proveedores">
      <div className="container">
        <div className="providerDreams__box">
          <span className="providerDreams__tag">También queremos verte aquí</span>

          <h2>¿Eres proveedor? Únete a Dreams XV</h2>

          <p>
            Muestra tu negocio frente a futuras quinceañeras y familias que están
            buscando proveedores para hacer realidad una fiesta inolvidable.
          </p>

          <a
            href="https://dreamsxv.com/proveedores.html"
            target="_blank"
            rel="noreferrer"
            className="providerDreams__btn"
          >
            Quiero aparecer en Dreams XV
          </a>
        </div>
      </div>
    </section>
  );
};

export default ProviderCTA;